import {createAsyncThunk} from '@reduxjs/toolkit';
import Api, {ApiMethods} from '../../../middleware/api';
import {notify} from '../../notifier/services/actions';
import {ProjectInfoDto} from '../../../dto/ProjectInfoDto';
import {FeedbackDto} from '../../../dto/FeedbackDto';
import {ProjectProfiles} from '../typedef';

type Args = {
    profileId: number;
    periodId: number;
    projectId: number;
};

export const getProjects = createAsyncThunk(
    'feedbackOverview/getProjects',
    async (_, {dispatch, rejectWithValue, requestId}) => {
        const {httpStatus, responseData} = await Api.fetch({
            endpoint: 'project/overview-projects-info',
            method: ApiMethods.GET
        });
        if (httpStatus === 200) {
            return responseData as ProjectInfoDto[];
        }
        dispatch(notify({message: responseData.message, key: requestId, variant: 'error'}));
        return rejectWithValue(responseData);
    }
);

export const getFeedbacks = createAsyncThunk<FeedbackDto[], Args>(
    'feedbackOverview/getFeedbacks',
    async ({profileId, periodId, projectId}, {dispatch, rejectWithValue, requestId}) => {
        const {httpStatus, responseData} = await Api.fetch({
            endpoint: `feedback/overview/${profileId}?periodId=${periodId}&projectId=${projectId}`,
            method: ApiMethods.GET
        });
        if (httpStatus === 200) {
            return responseData;
        }
        dispatch(notify({message: responseData.message, key: requestId, variant: 'error'}));
        return rejectWithValue(responseData);
    }
);

type GetProfilesArgs = {
    projectId: number;
    profileIds: number[];
};

export const getProfiles = createAsyncThunk<ProjectProfiles, GetProfilesArgs>(
    'feedbackOverview/getProfiles',
    async ({projectId, profileIds}, {dispatch, rejectWithValue, requestId}) => {
        const {httpStatus, responseData} = await Api.fetch({
            endpoint: 'profiles/',
            method: ApiMethods.POST,
            body: profileIds
        });
        if (httpStatus === 200) {
            return {projectId, profiles: responseData};
        }
        dispatch(notify({message: responseData.message, key: requestId, variant: 'error'}));
        return rejectWithValue(responseData);
    }
);
